import React from "react";
import PageHero from "../../COMPONENTS/PAGE_HERO";
import PageNav from "../../COMPONENTS/PAGE_NAV";
import ContactBlock from "../../COMPONENTS/CONTACT_BLOCK";
import Accordion from "../../COMPONENTS/ACCORDION";
import { Section, SectionIntro } from "../../COMPONENTS/UI";
import PatientContactForm from "../../COMPONENTS/FORM/PATIENT_CONTACT";
import { Expect } from "./SECTIONS/LEARN";
import { faqs, patientsHero } from "../../CONTENT/patients";
import useDocumentMeta from "../../UTILS/HOOKS/useDocumentMeta";

const links = [
  { id: "expect", label: "What to expect" },
  { id: "faq", label: "FAQ" },
  { id: "contact", label: "Talk to us" },
];

const PatientsPage = () => {
  useDocumentMeta({
    title: "For Patients | Clinical Trials with KUR Research",
    description:
      "Learn what clinical research is, what to expect when you take part, and how to talk to a KUR patient advocate about volunteering for a clinical trial.",
    path: "/patients",
  });

  return (
    <>
      <PageHero
        id="patients-hero-title"
        title={
          <>
            You can be part of <em>the answer.</em>
          </>
        }
        lead={patientsHero.lead}
        actions={patientsHero.actions}
        note={patientsHero.note}
        image={patientsHero.image}
        imageAlt={patientsHero.imageAlt}
      />
      <PageNav links={links} cta={{ label: "Talk to a patient advocate", href: "#contact" }} />
      <Expect />
      <Section tone="light" id="faq" labelledBy="faq-title">
        <SectionIntro id="faq-title" eyebrow="FAQ" title="Frequently asked questions" />
        <Accordion items={faqs.map((f) => ({ title: f.question, body: <p>{f.answer}</p> }))} />
      </Section>
      <ContactBlock
        eyebrow="Talk to a patient advocate"
        title="Interested in volunteering for a clinical trial or want to know more about the process?"
        lead="Please fill the information below and a patient advocate will reach out to you."
        note="Submitting this form does not enroll you in a study or confirm eligibility. Every study has its own criteria, which a patient advocate will review with you."
      >
        <PatientContactForm />
      </ContactBlock>
    </>
  );
};

export default PatientsPage;
